import { NODE_HEIGHT, NODE_WIDTH } from './constants'
import type { FlowNode, FlowNodeData, NodeType, Point } from './types'

const DEFAULTS: Record<NodeType, { label: string; data: () => FlowNodeData }> = {
  start: { label: 'Start Session', data: () => ({}) },
  end: { label: 'End Flow', data: () => ({}) },
  'macro-start': { label: 'Macro Start', data: () => ({ macroName: '', inputCount: 1 }) },
  'macro-end': { label: 'Macro End', data: () => ({ macroRef: '', outputCount: 1 }) },
  'macro-call': {
    label: 'Macro',
    data: () => ({ macroRef: '', inputCount: 1, outputCount: 1 }),
  },
  group: { label: 'Group Gate', data: () => ({}) },
  condition: {
    label: 'Condition',
    data: () => ({ condLeft: 'R1', condOp: '==', condRight: 'literal', condRightLit: 0 }),
  },
  phase: { label: 'Phase 1', data: () => ({ phaseId: 'phase-1' }) },
  action: { label: 'Action', data: () => ({ actionType: 'pull-next-card' }) },
}

/**
 * Creates a node of `type` centred on `center` (world coordinates).
 * Group gates default to the first known deck group.
 */
export function createNode(
  id: string,
  type: NodeType,
  center: Point,
  defaultGroupId: string,
): FlowNode {
  const defaults = DEFAULTS[type] ?? DEFAULTS.action
  const data = type === 'group' ? { groupId: defaultGroupId } : defaults.data()
  return {
    id,
    type,
    label: defaults.label,
    x: Math.round(center.x - NODE_WIDTH / 2),
    y: Math.round(center.y - NODE_HEIGHT / 2),
    data,
  }
}

/** Places an existing node so that `position` becomes its centre. */
export function centerNodeAt(node: FlowNode, position: Point) {
  node.x = Math.round(position.x - NODE_WIDTH / 2)
  node.y = Math.round(position.y - NODE_HEIGHT / 2)
}
